module.exports = __webpack_public_path__ + "static/the-myth-of-the-spoiled-child-fe01d85fbd6219de5001611aa669685b.jpg";